import {
  convertStringToDateWithoutTime, compareDates, formatDateToLocaleDateShort
} from '../../utils/date'
import validator from 'validator'
import { interpolate, PLACEHOLDERS } from '../../language'
import envSettings from '../../globals/envSettings'

export const backupCards = [
  {
    title: 'Parental Engagement',
    content: '<ul><li><strong>NEW CONTENT!</strong></li><li>In English</li><li>For all ELT and CLIL Pre-Primary, Primary and Secondary teachers</li><li>5 hours</li><li>Tips and strategies to help parents support their children’s language development.</li><li>The benefits of parental engagement.</li><li>How to develop the home learning environment.</li><li>Challenges and solutions.</li><li>Practice and reflections.</li><li>Certified by Oxford University Press España</li></ul>',
    masterCourse: 'Master_PARENTALENGAGEMENT'
  },
  {
    title: 'Emotions in Mind: Preparing for Exam Success',
    content: '<ul><li><strong>NEW CONTENT!</strong></li><li>In English.</li><li>For ELT and CLIL Primary (last cycle) and Secondary teachers.&nbsp;</li><li>20 hours.</li><li>5 modules.</li><li>Learners’ emotions and their impact on their academic performance.</li><li>Emotional regulation and strategies for coping with exam stress.</li><li>Regulation strategies for teachers.</li><li>Oficially certified by the Institute for Professional Development at the Universitat de Barcelona.</li></ul>',
    masterCourse: 'Master_EMOTIONSINMIND'
  },
  {
    title: 'Resolución de conflictos',
    content: '<ul><li>En castellano.</li><li>Para profesorado de todas las etapas. </li><li>20 horas.</li><li>4 módulos.</li><li>¿Cuáles son las causas de conflictos en el aula y cómo solucionarlos?&nbsp;</li><li>Herramientas&nbsp;para crear un ambiente de aprendizaje armonioso en el aula.&nbsp;</li><li>Certificación oficial del Instituto de Desarrollo Profesional de la Universidad de Barcelona.</li></ul>',
    masterCourse: 'Master_RESOLUCIONCONFLICTOS'
  },
  {
    title: 'Classroom Management',
    content: '<ul><li>In English.</li><li>For all ELT and CLIL Primary and Secondary teachers.</li><li>20 hours.</li><li>5 modules.</li><li>Practical&nbsp;advice on how to&nbsp;manage resources,&nbsp;time&nbsp;and students.&nbsp;</li><li>Hands-on insights into using language,&nbsp;body&nbsp;and voice effectively in the classroom.</li><li>Oficially certified by the Institute for Professional Development at the Universitat de Barcelona.</li></ul>',
    masterCourse: 'Master_CLASSROOMMANAGEMENT'
  }
]

export const adjustCards = cards => {
  let styleCardsCol = 'text-left'
  if (cards && cards.length && cards.length === 1) {
    styleCardsCol = styleCardsCol + ' offset-md-3 offset-lg-4'
  }
  return styleCardsCol
}

// MBQ TODO Revisar uso de announcement.isCurrent con SP convocatoria
export const fillAnnouncement = (announcement, locale) => {
  let result = null
  if (announcement) {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const startDate = convertStringToDateWithoutTime(announcement.registrationStartDate)
    startDate.setHours(0, 0, 0, 0)
    const endDate = convertStringToDateWithoutTime(announcement.registrationEndDate)
    endDate.setHours(0, 0, 0, 0)
    announcement.registrationStartDateShort = formatDateToLocaleDateShort(startDate, locale)
    announcement.registrationEndDateShort = formatDateToLocaleDateShort(endDate, locale)
    announcement.registrationOn = (
      announcement.isCurrent &&
      [0, 2].includes(compareDates(startDate, today)) &&
      [0, 1].includes(compareDates(endDate, today))
    ) ? true : false
    if (!announcement.registrationOn && announcement.nextAnnouncement && announcement.nextAnnouncement.registrationStartDate) {
      announcement.nextAnnouncement.registrationStartDateShort =
        formatDateToLocaleDateShort(convertStringToDateWithoutTime(announcement.nextAnnouncement.registrationStartDate), locale)
    }
    result = announcement
  }
  return result
}

export const fillCurrentRegistration = (registration, locale) => {
  let result = null
  if (registration) {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const startDate = registration.courseAccessDate ?
      convertStringToDateWithoutTime(registration.courseAccessDate) : convertStringToDateWithoutTime(registration.courseStartDate)
    startDate.setHours(0, 0, 0, 0)
    const endDate = convertStringToDateWithoutTime(registration.courseEndDate)
    endDate.setHours(0, 0, 0, 0)
    registration.courseStartDateShort = formatDateToLocaleDateShort(startDate, locale)
    registration.courseEndDateShort = formatDateToLocaleDateShort(endDate, locale)
    registration.accessOn = (
      registration.courseLtiKey &&
      registration.courseLtiSecret &&
      registration.courseLtiUrl &&
      validator.isURL(registration.courseLtiUrl) &&
      [0, 2].includes(compareDates(startDate, today)) &&
      [0, 1].includes(compareDates(endDate, today))
    ) ? true : false
    result = registration
  }
  return result
}

export const sanitizeField = (field, blacklist = ['<p>', '</p>', '\n']) => {
  let result = field
  blacklist.forEach(element => {
    result = result.replace(element, '')
  })
  return result
}

export const checkCompletedCourses = (courses, registrations) => {
  if (!registrations || registrations.length === 0) return courses
  return courses.map(course => {
    course.completed = registrations.some(registration => (
      registration.lmsMasterCourseId === course.lmsMasterCourseId)
    )
    return course
  })
}

export const getCatalogue = (cards, completedRegistrations, courses, registration) => {
  let catalogue = []
  if (cards && cards.length > 0) {
    catalogue = cards.reduce((acc, card) => {
      if (
        (completedRegistrations && completedRegistrations.length &&
          completedRegistrations.some(registration => registration.lmsMasterCourseId === card.masterCourse)) ||
        (registration && registration.lmsMasterCourseId === card.masterCourse) ||
        (courses && courses.length &&
          !courses.some(course => course.lmsMasterCourseId === card.masterCourse))
      )
        return acc
      acc.push(card)
      return acc
    }, [])
  }
  return catalogue
}

export const MIN_BIRTHDAY = "1900-01-01"

export const getMaxBithday = () => {
  const today = new Date()
  const maxDate = `${today.getFullYear()}-${((today.getMonth() + 1) + '').padStart(2, '0')}-${(today.getDate() + '').padStart(2, '0')}`
  return maxDate
}

export const MAX_BIRTHDAY = getMaxBithday()

export const validateBirthday = birthday => {
  if (!birthday || !/^\d{4}-\d{1,2}-\d{1,2}$/.test(birthday)) return false
  const birthdayDate = convertStringToDateWithoutTime(birthday)
  birthdayDate.setHours(0, 0, 0, 0)
  const minDate = convertStringToDateWithoutTime(MIN_BIRTHDAY)
  minDate.setHours(0, 0, 0, 0)
  const maxDate = convertStringToDateWithoutTime(MAX_BIRTHDAY)
  maxDate.setHours(0, 0, 0, 0)
  if (
    ![0, 2].includes(compareDates(minDate, birthdayDate)) ||
    ![0, 1].includes(compareDates(maxDate, birthdayDate))
  ) return false
  return true
}

export const REGISTRATION_ACTION = {
  INSERT: 'ALTA',
  DELETE: 'BAJA'
}

export const TABS = {
  ANNOUNCEMENT: '1',
  MY_COURSES: '2',
  COMPLETED_COURSES: '3'
}

export const getTitle = (announcement, isCurrentRegistration, glossary_pdcourses) => {
  let title = null
  if (isCurrentRegistration) {
    title = glossary_pdcourses.mycourses_catalogue_title_1
  } else if (announcement && announcement.isCurrent && announcement.registrationOn) {
    title = interpolate(glossary_pdcourses.current_announcement_title_1, PLACEHOLDERS.NAME, announcement.description)
  } else {
    title = glossary_pdcourses.noncurrent_announcement_title_1
  }
  return title
}

export const getSubTitle = (announcement, isCurrentRegistration, glossary_pdcourses) => {
  let subTitle = null
  if (isCurrentRegistration) {
    subTitle = glossary_pdcourses.mycourses_catalogue_title_2
    //} else if (announcement && announcement.isCurrent && announcement.registrationOn) {
  } else if (announcement && announcement.isCurrent) {
    if (announcement.registrationOn) {
      subTitle = interpolate(glossary_pdcourses.current_announcement_title_2, PLACEHOLDERS.DATE, announcement.registrationEndDateShort)
    } else {
      subTitle = announcement.nextAnnouncement && announcement.nextAnnouncement.registrationStartDateShort ?
        interpolate(glossary_pdcourses.noncurrent_announcement_title_2, PLACEHOLDERS.DATE, announcement.nextAnnouncement.registrationStartDateShort)
        : ''
    }
  } else if (announcement && !announcement.isCurrent) {
    subTitle = interpolate(glossary_pdcourses.noncurrent_announcement_title_2, PLACEHOLDERS.DATE, announcement.registrationStartDateShort)
  } else {
    subTitle = ''
  }
  return subTitle
}

export const getCourseMiniature = (masterCourse, locale) => (
  `${envSettings.STATIC_URL || 'https://static.dev.oupe.es'}/pdcourses/${masterCourse}_${locale}.png`
)

export const ENTITY = {
  IDP: 'IDP',
  OUPE: 'OUPE'
}

const certifications = {
  [ENTITY.IDP]: [1],
  [ENTITY.OUPE]: [0]
}

export const receiveCertification = ({ courseCertificate, courseTrainingEntity}) => {
  if(!certifications[courseTrainingEntity]) return false
  return certifications[courseTrainingEntity].includes(courseCertificate)
}
